import { queryOptions } from '@tanstack/react-query';
import { getKeywordsAssistance4Site } from 'src/common/Scraper';
import { KeywordAssistApiResponse } from '../../types/keyword-assist.type';

function getKeywordsAssistance4Url(userId: string, siteId: string) {

  return queryOptions({
    queryKey: ['keywords-assistance', userId, siteId],
    queryFn: () => getKeywordsAssistance4Site(userId, siteId) as Promise<KeywordAssistApiResponse>,
    enabled: !!siteId
  });
}

export default getKeywordsAssistance4Url;
